import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Flex from '../../atoms/Flex';
import UserImage from '../../atoms/user/UserImage';
import UserName from '../../atoms/user/UserName';
import Account from '../../atoms/icons/Account';
import { getAppThemeName } from '../../../services/appTheme';
const StyledAccount = styled(Account) `
    fill: ${getAppThemeName() === 'invoned'
    ? props => props.theme.tertiary
    : props => props.theme.primary.base};
    margin-right: 6px;
`;
const CurrentUser = ({ userName, userImageUrl }) => (_jsxs(Flex, { alignItems: "center", children: [userImageUrl ? (_jsx(_Fragment, { children: _jsx(UserImage, { userImageUrl: userImageUrl }) })) : (_jsx(_Fragment, { children: _jsx(StyledAccount, {}) })), _jsx(UserName, { userName: userName })] }));
export default CurrentUser;
